import { ColumnVisibleEvent, GridApi } from '@ag-grid-community/core'
import { Subject, Subscription } from 'rxjs'
import { debounceTime } from 'rxjs/operators'

const cache: { [key: string]: Subject<GridApi> | undefined } = {}
/** @internal */
export const subs: { [key: string]: Subscription | undefined } = {}

/**
 * The amount of time that reloading the data will occur
 */
const DEBOUNCE_TIME = 1000

/**
 * Refresh the ag grid when a new column visibility has changed.
 *
 * Few things to look out for:
 * 1. If called every time visibility changes, there is a degrade in
 *    UI performance and experience
 */
export function handleColumnVisibilityChange(
  event: ColumnVisibleEvent,
  name: string,
) {
  if (!cache[name]) {
    const gridApiSubject = new Subject<GridApi>()
    cache[name] = gridApiSubject
    const sub = gridApiSubject
      .pipe(debounceTime(DEBOUNCE_TIME))
      .subscribe(api => {
        api.refreshServerSideStore({})
        sub.unsubscribe()
        subs[name] = undefined
        cache[name] = undefined
      })

    // Just in case
    if (subs[name]) {
      subs[name]?.unsubscribe()
    }

    subs[name] = sub
  }

  // At this point, it won't be undefined
  const subject = cache[name] as Subject<GridApi>

  // Don't reload on non-visible columns
  if (event.visible) {
    subject.next(event.api)
  }
}
